<template lang="pug">
.res-info-card(:class="[size, {'gray': isGray}]" @click="onToDetail")
  .top
    .date {{year}}年{{month}}月{{day}}日
    .copy(v-if="noArrow") {{resStatusVO.msg}}
    arrow-btn-blue(v-if="!noArrow" :copy="resStatusVO.msg")
  .bottom
    time-range(:fs1="size==='l'? 30: 22"  :fs2="size==='l'? 90: 60"  :schedule="res.schedule")
  
</template>
<script>
import TimeRange from '@/components/wedgits/TimeRange'
import ArrowBtnBlue from '@/components/wedgits/ArrowBtnBlue'
import {
  getResStatus,
  RES_STATUS,
  getResVOStatus,
  RES_SCHEDULE_STATUS,
} from '@/helpers/ResHelper'
import { mapMutations } from 'vuex'

export default {
  name: 'ResInfoCard',
  components: { ArrowBtnBlue, TimeRange },
  props: {
    res: {},
    size: {
      default: 'm',
    },
    id: {},
    noArrow: {
      default: false,
    },
    from: {},
  },
  data() {
    return {
      RES_STATUS: RES_STATUS,
    }
  },
  computed: {
    month() {
      let mon = this.res.schedule.from.getMonth() + 1
      if (mon < 10) return `0${mon}`
      else return mon
    },
    year() {
      return this.res.schedule.from.getFullYear()
    },
    day() {
      return this.res.schedule.from.getDate()
    },
    // status() {
    //   return getResStatus(
    //     this.res.schedule.from,
    //     this.res.schedule.to,
    //     this.res.resStatus
    //   )
    //   // if (this.res.resStatus === 2) return 4
    //   // let now = Date.now()
    //   // let gap = this.res.schedule.from.getTime() - now
    //   // gap = gap / (1000 * 3600)
    //   // if (gap < 0) return 2
    //   // else if (gap < 2) return 1
    //   // else return 0
    // },
    isGray() {
      if (
        this.res.resStatus === RES_STATUS.CREATED ||
        this.resStatus === RES_STATUS.RESCHEDULED
      ) {
        return false
      } else if (this.res.resStatus === RES_STATUS.CANCELED) {
        return true
      } else if (this.res.resStatus === RES_STATUS.REDEEMED) {
        return true
        // if (this.res.resScheduleStatus === RES_SCHEDULE_STATUS.PASSED)
        //   return true
      }
      return false
      //status===RES_STATUS.REDEEMED || status === RES_STATUS.CANCELLED
    },
    resStatusVO() {
      return this.$t(`reservation.resStatusVO[${getResVOStatus(this.res)}]`)
    },
    // statusMsg() {
    //   return this.$t(`reservation.resVOStatus[${getResVOStatus(this.res)}`).msg
    //   // if (this.res.resStatus === RES_STATUS.CANCELED) {
    //   //   return this.$t('reservation.resStatus')[RES_STATUS.CANCELED].msg
    //   // } else if (this.res.resStatus === RES_STATUS.REDEEMED) {
    //   //   return this.$t('reservation.resStatus')[RES_STATUS.REDEEMED].msg
    //   // } else if (this.res.resScheduleStatus === RES_SCHEDULE_STATUS.EARLY) {
    //   //   if (this.res.resStatus === RES_STATUS.RESCHEDULED) {
    //   //     return this.$t('reservation.resStatus')[RES_STATUS.RESCHEDULED].msg
    //   //   } else if (this.res.resStatus === RES_STATUS.CREATED) {
    //   //     return this.$t('reservation.resStatus')[RES_STATUS.CREATED].msg
    //   //   }
    //   // } else if (this.res.resScheduleStatus === RES_SCHEDULE_STATUS.COMING) {
    //   //   return this.$t('reservation.resScheduleStatus')[
    //   //     RES_SCHEDULE_STATUS.COMING
    //   //   ].msg
    //   // } else if (this.res.resScheduleStatus === RES_SCHEDULE_STATUS.PASSED) {
    //   //   return this.$t('reservation.resScheduleStatus')[
    //   //     RES_SCHEDULE_STATUS.PASSED
    //   //   ].msg
    //   // } else if (this.res.resScheduleStatus === RES_SCHEDULE_STATUS.ON_GOING) {
    //   //   return this.$t('reservation.resScheduleStatus')[
    //   //     RES_SCHEDULE_STATUS.ON_GOING
    //   //   ].msg
    //   // }
    //   // return ''
    // },
  },
  methods: {
    ...mapMutations('app', ['setRouterBack']),
    onToDetail() {
      this.setRouterBack(this.from)
      this.$router.replace(`/me/res/${this.id}`)
    },
  },
  mounted() {
    let now = Date.now()
    console.log(this.res, this.res.schedule.from.getTime() - now)
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.res-info-card
  background: #ffffff
  width: 100%
  height: 100%
  display: flex
  justify-content: space-between
  align-items: flex-start
  flex-direction: column
  color: #1677FF
  padding: pxToRem(30)
  box-shadow: 0 pxToRem(-1) pxToRem(10) 0 rgba(226,226,226,0.73)
  border-radius: pxToRem(16)
  &.gray
    filter: grayscale(1)
  &.l
    padding: pxToRem(40)
    width: 100%
    height: pxToRem(242)
    .top
      .date
        font-size: pxToRem(36)
        line-height: pxToRem(50)
        letter-spacing: pxToRem(0.8)
  .top
    width: 100%
    display: flex
    flex-direction: row
    align-items: center
    justify-content: space-between
    .date
      font-size: pxToRem(30)
      letter-spacing: pxToRem(0.8)
    .copy
      font-size: pxToRem(30)
      color: $cl-blue
      line-height: 0
  .bottom
    width: 100%
    //.status
      font-size: pxToRem(30)
</style>
